<template>
  <div class="pt-1 pb-2 pr-1 pl-1">
    <div class="no-gutters mt-1 ml-3 mr-3">
      <div class="row">
        <div class="col-6">
          <div class="parameter-box">
            <h4>
              {{ speed_over_ground }} <small>kn</small>
            </h4>
            <div class="parameter-name">Speed over ground</div>
          </div>
        </div>
        <div class="col-6">
          <div class="parameter-box">
            <h4>
              {{ roundDigits(course_over_ground, 1) }}<small>°</small>
              <font-awesome-icon :icon="['fas', 'location-arrow']" size="xs" class="text-info ml-2" :style="{ transform: rotateArrow(course_over_ground) }" />
            </h4>
            <div class="parameter-name">Course over ground</div>
          </div>
        </div>
        <div class="col-6">
          <div class="parameter-box">
            <h4>
              {{ roundDigits(heading, 1) }}<small>°</small>
              <font-awesome-icon :icon="['fas', 'location-arrow']" size="xs" class="text-info ml-2" :style="{ transform: rotateArrow(heading) }" />
            </h4>
            <div class="parameter-name">Heading</div>
          </div>
        </div>
        <div class="col-6">
          <div class="parameter-box">
            <h4>
              {{ roundDigits(wing_heading, 1) }}<small>°</small>
              <font-awesome-icon :icon="['fas', 'location-arrow']" size="xs" class="text-info ml-2" :style="{ transform: rotateArrow(wing_heading) }" />
            </h4>
            <div class="parameter-name">Wing heading</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="parameter-box">
            <h4>
              {{ showDigits(air_temperature, 1) }} <small>°C</small>
            </h4>
            <div class="parameter-name">Air temperature</div>
          </div>
        </div>
        <div class="col-6">
          <div class="parameter-box">
            <h4>
              {{ showDigits(air_pressure, 0) }} <small>hPa</small>
            </h4>
            <div class="parameter-name">Air pressure</div>
          </div>
        </div>
        <div class="col-6">
          <div class="parameter-box">
            <h4>
              {{ showDigits(water_temperature, 1) }} <small>°C</small>
            </h4>
            <div class="parameter-name">Water temperature</div>
          </div>
        </div>
        <div class="col-6">
          <div class="parameter-box">
            <h4>
              {{ showDigits(salinity, 1) }} <small>PSU</small>
            </h4>
            <div class="parameter-name">Salinity</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Helpers from '@/mixins/helpers'

export default {
  name: 'GenericStatusWidget',
  mixins: [
    Helpers
  ],
  data: function () {
    return {}
  },
  props: ['platformId'],
  methods: {
    rotateArrow: function (heading) {
      return 'rotate(' + Number(Number(heading) - 45) + 'deg)'
    }
  },
  computed: {
    ...mapState(['platforms']),
    ...mapGetters(['currentUpdate', 'lastUpdate']),
    position () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude, 5),
        this.roundDigits(this.longitude, 5))
      return position.lat + ' ' + position.lng
    },
    latitude () {
      const update = this.currentUpdate(this.platformId, 1, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    longitude () {
      const update = this.currentUpdate(this.platformId, 1, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    speed_over_ground () {
      const update = this.currentUpdate(this.platformId, 1, 106)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    course_over_ground () {
      const update = this.currentUpdate(this.platformId, 1, 100)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    heading () {
      const update = this.currentUpdate(this.platformId, 1, 3)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    wing_heading () {
      const update = this.currentUpdate(this.platformId, 1, 112)
      return (update.length !== 0) ? (this.heading - 180) + Number(update[1]) : 0
    },
    air_temperature () {
      const update = this.currentUpdate(this.platformId, 201, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    air_pressure () {
      const update = this.currentUpdate(this.platformId, 201, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    water_temperature () {
      const update = this.currentUpdate(this.platformId, 202, 3)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    salinity () {
      const update = this.currentUpdate(this.platformId, 202, 5)
      return (update.length !== 0) ? Number(update[1]) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.parameter-box {
  padding: 10px 10px 5px 10px;
}
.parameter-box h4 {
  margin-bottom: 2px;
}
.parameter-box h5 {
  margin-bottom: 2px;
}
.parameter-name {
  font-size: 11px;
  color: #6c757d;
}
.state-box {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  vertical-align: bottom;
  border-radius: 2px;
  padding: 5px 2px 5px 2px;
}
.state-ok {
  background-color: #82E0AA;
  color: #186A3B;
}
.state-danger {
  background-color: #F1948A;
  color: #78281F;
}
.no-gutters {
  margin-right: 10px;
  margin-left: 10px;
  .col,
  [class*="col-"] {
    padding-right: 2px;
    padding-left: 2px;
  }
}
</style>
